import { useGetOrganisationQuery } from '../../generated/core-api/graphql-react-query';

export function useOrganisation() {
  const org = useGetOrganisationQuery({}, {
    retry: false,
  });
  return {
    ...org,
    ...org.data && {
      data: {
        ...org.data,
        org: {
          ...org.data.org,
          ...(!org.data.org.enableAlternativeAsrApi && !org.data.org.enableCoreAsrApi) && {
            enableCoreAsrApi: true,
            enableAlternativeAsrApi: false,
          },
        },
      },
    },
  };
}

export function useOrganisationData() {
  const org = useOrganisation();
  if (!org.data) {
    throw new Error('Organisation not loaded');
  }
  return org.data.org;
}
